import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { iconList } from "@/const/v3-icon-list";


export default /*#__PURE__*/_defineComponent({
  __name: 'V3Icon',
  props: {
    icon: null
  },
  setup(__props: any) {

const props = __props as {
  icon: string;
};



const icon = computed(() => iconList[props.icon]);

return { __sfc: true,props, icon }
}

})